/*
 * COPYRIGHT. HSBC HOLDINGS PLC 2017. ALL RIGHTS RESERVED.
 *
 * This software is only to be used for the purpose for which it has been
 * provided. No part of it is to be reproduced, disassembled, transmitted,
 * stored in a retrieval system nor translated in any human or computer
 * language in any way or for any other purposes whatsoever without the
 * prior written consent of HSBC Holdings plc.
 *
 */
import React from 'react';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import StepFooter from './StepFooter';
import '../style/agreement.css';
import BasePage from '../../../shared/BasePage';

class Agreement extends BasePage {
    constructor(props) {
        super(props);
        this.linkAction = this.linkAction.bind(this);
    }

    linkAction (idx) {
        const { selectedLanguage } = this.props;
        switch (idx) {
            case 1:
                if (selectedLanguage === 'zh-CN') {
                    window.open("https://www.business.hsbc.com.cn/-/media/library/markets-selective/china/pdfs/general-terms-and-conditions-cn.pdf", "_blank");
                } else {
                    window.open("https://www.business.hsbc.com.cn/-/media/library/markets-selective/china/pdfs/general-terms-and-conditions-en.pdf", "_blank")
                }
                break;
            case 3:
                if (selectedLanguage === 'zh-CN') {
                    window.open("https://www.business.hsbc.com.cn/-/media/library/markets-selective/china/pdfs/tariff-of-accounts-and-services-cn.pdf", "_blank");
                } else {
                    window.open("https://www.business.hsbc.com.cn/-/media/library/markets-selective/china/pdfs/tariff-of-accounts-and-services-en.pdf", "_blank");
                }
                
                break;
            case 2:
            case 4:
                if (selectedLanguage === 'zh-CN') {
                    window.open("https://www.hsbc.com.cn", "_blank"); 
                } else {
                    window.open("https://www.hsbc.com.cn", "_blank"); 
                }
                break;
            default:
                break;
        }
    }

    render () {
        //const { linkAction } = this.props;
        const legalContents = this.props.agreementContent.legalContents;
        return (
            <div className="dynamic-form ao-form container" data-id={'Agreement-Agreement-page'}>
                <div className="form-title-row">
                    <div className="agreement-title clearfix"><h5 data-key={'agreement.legalContents.title'}>{legalContents.title}</h5></div>
                    <div className="agreement-container">
                        <div className="agreement-content">
                            <div className="agreement-main" data-key={'agreement.legalContents.detail'}>
                                <FormattedHTMLMessage id="chapter-terms1" defaultMessage={legalContents.detail1} /><br/>
                                <ol start="1">
                                    <li>
                                        <FormattedMessage id="checkBoxValue"
                                            defaultMessage={legalContents.detail1a}
                                            values={{
                                                link1: <span><b tabIndex="0" role="link" onClick={() => this.linkAction(1)} data-key="legalContents.link1">{legalContents.link1}</b> <i className="icon icon-new-window"></i></span>,
                                                link2: <span><b tabIndex="0" role="link" onClick={() => this.linkAction(2)} data-key="legalContents.link2">{legalContents.link2}</b> <i className="icon icon-new-window"></i></span>
                                            }}
                                        />
                                    </li>
                                    <li>
                                        <FormattedMessage id="checkBoxValue"
                                            defaultMessage={legalContents.detail1b}
                                            values={{
                                                link3: <span><b tabIndex="0" role="link" onClick={() => this.linkAction(3)} data-key="legalContents.link3">{legalContents.link3}</b> <i className="icon icon-new-window"></i></span>,
                                                link4: <span><b tabIndex="0" role="link" onClick={() => this.linkAction(4)} data-key="legalContents.link4">{legalContents.link4}</b> <i className="icon icon-new-window"></i></span>
                                            }}
                                        />
                                    </li>
                                </ol>
                                <div className="block-height"></div>
                                <FormattedHTMLMessage id="chapter-terms2" defaultMessage={legalContents.detail2} />
                                <div className="block-height"></div>
                                <FormattedHTMLMessage id="chapter-terms3" defaultMessage={legalContents.detail3} />
                                <div className="block-height"></div>
                                <FormattedHTMLMessage id="chapter-terms4" defaultMessage={legalContents.detail4} />
                                <div className="block-height"></div>
                                <FormattedHTMLMessage id="chapter-terms5" defaultMessage={legalContents.detail5} /><br/>
                            </div>
                        </div>
                    </div>
                    <StepFooter
                        dataId={'Agreement-AgreementStepFooter-Footer'}
                        {...this.props}
                    />
                </div>
            </div>
        )
    }
}

export default Agreement;



// WEBPACK FOOTER //
// ./src/views/Agreement/components/Agreement.js